import { forwardRef } from 'react';
import Box from '../Box/Box.js';
import { IconButton } from '../Button/IconButton.js';
import '../Button/ButtonBase.js';
import '../utils/defaultSxProp.js';
import { jsx } from 'react/jsx-runtime';
import { ButtonComponent } from '../Button/Button.js';
import { clsx } from 'clsx';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';
import classes from './ActionList.module.css.js';
import { actionListCssModulesFlag } from './featureflag.js';

const TrailingAction = /*#__PURE__*/forwardRef(({
  as = 'button',
  icon,
  label,
  href = null,
  className,
  ...props
}, forwardedRef) => {
  const enabled = useFeatureFlag(actionListCssModulesFlag);
  if (enabled) {
    return /*#__PURE__*/jsx("span", {
      className: clsx(className, classes.TrailingAction),
      children: icon ? /*#__PURE__*/jsx(IconButton, {
        as: as,
        "aria-label": label,
        icon: icon,
        variant: "invisible",
        tooltipDirection: "w",
        href: href
        // @ts-expect-error StyledButton wants both Anchor and Button refs
        ,
        ref: forwardedRef,
        className: classes.TrailingActionButton,
        ...props
      }) :
      /*#__PURE__*/
      // @ts-expect-error shhh
      jsx(ButtonComponent, {
        variant: "invisible",
        as: as,
        href: href,
        ref: forwardedRef,
        className: classes.TrailingActionButton,
        ...props,
        children: label
      })
    });
  }
  return /*#__PURE__*/jsx(Box, {
    as: "span",
    "data-component": "ActionList.TrailingAction",
    sx: {
      flexShrink: 0
    },
    className: className,
    children: icon ? /*#__PURE__*/jsx(IconButton, {
      as: as,
      "aria-label": label,
      icon: icon,
      variant: "invisible",
      tooltipDirection: "w",
      href: href
      // @ts-expect-error StyledButton wants both Anchor and Button refs
      ,
      ref: forwardedRef,
      ...props
    }) :
    /*#__PURE__*/
    // @ts-expect-error shhh
    jsx(ButtonComponent, {
      variant: "invisible",
      as: as,
      href: href,
      ref: forwardedRef,
      ...props,
      children: label
    })
  });
});
TrailingAction.displayName = 'ActionList.TrailingAction';

export { TrailingAction };
